// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__DhGBu","content":"LoadingAlert_content__2v4kp"};